var validationScroll;

if (typeof Page_ClientValidate !== 'undefined') {
    var originalValidationFunction = Page_ClientValidate;
    if (originalValidationFunction && typeof (originalValidationFunction) == 'function') {
        Page_ClientValidate = function (validationGroup) {
            validationScroll = null;
            originalValidationFunction(validationGroup);
            if (!Page_IsValid && typeof validationScroll != 'undefined' || validationScroll != null) {
                WizardScroll(validationScroll, 25);
            }
        };
    }
}

function validateAnswers(source, arguments) {
    var $questionWrapper = $(source).closest('.el-module-question');
    var allowedAnswers = $questionWrapper.attr('data-allowed-answers');
    var $answers = $questionWrapper.find('.el-module-question__answers');
    if ($answers.find('input[type=radio]:checked, input[type=checkbox]:checked').length == allowedAnswers) {
        arguments.IsValid = true;
    }
    else {
        arguments.IsValid = false;
        if (typeof validationScroll == 'undefined' || validationScroll == null || $questionWrapper.offset() < validationScroll.offset()) {
            validationScroll = $questionWrapper;
        }
    }
}

$(function () {
    if (typeof Vimeo !== 'undefined') {
        $('[data-video-show-end]').hide();

        var iframe = $('.embed-container iframe');
        var player = new Vimeo.Player(iframe);

        player.on('ended', function () {
            $('[data-video-show-end]').show();
        });
    }
});